export default {"src":"/_next/static/media/home-page-slider-chevron-right.1b6d0e9d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};